import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import API_BASE_URL from "../config/api";


function AddSocialLinks() {

    const navigate = useNavigate();


    /*
    |--------------------------------------------------------------------------
    | Form State
    |--------------------------------------------------------------------------
    */

    const [whatsapp, setWhatsapp] = useState("");

    const [instagram, setInstagram] = useState("");

    const [facebook, setFacebook] = useState("");

    const [youtube, setYoutube] = useState("");

    const [telegram, setTelegram] = useState("");

    const [mobile, setMobile] = useState("");

    const [status, setStatus] = useState("Enable");


    /*
    |--------------------------------------------------------------------------
    | Saving
    |--------------------------------------------------------------------------
    */

    const [saving, setSaving] = useState(false);


    /*
    |--------------------------------------------------------------------------
    | WhatsApp Number Change
    |--------------------------------------------------------------------------
    */

    const handleWhatsappChange = (e) => {

        // केवल numbers allow करें
        const value = e.target.value.replace(/\D/g, "");

        // Maximum 15 digits
        setWhatsapp(value.slice(0, 15));
    };


    /*
    |--------------------------------------------------------------------------
    | Mobile Number Change
    |--------------------------------------------------------------------------
    */

    const handleMobileChange = (e) => {

        // केवल numbers allow करें
        const value = e.target.value.replace(/\D/g, "");

        setMobile(value.slice(0, 15));
    };


    /*
    |--------------------------------------------------------------------------
    | Submit
    |--------------------------------------------------------------------------
    */

    const handleSubmit = async (e) => {

        e.preventDefault();


        try {

            setSaving(true);


            const response = await fetch(
                `${API_BASE_URL}/admin/social-links`,
                {
                    method: "POST",

                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json"
                    },

                    credentials: "include",

                    body: JSON.stringify({
                        whatsapp: whatsapp.trim(),
                        instagram: instagram.trim(),
                        facebook: facebook.trim(),
                        youtube: youtube.trim(),
                        telegram: telegram.trim(),
                        mobile: mobile.trim(),
                        status: status
                    })
                }
            );


            const data = await response.json();


            if (response.ok && data.success) {

                await Swal.fire({

                    icon: "success",

                    title: "Saved!",

                    text:
                        data.message ||
                        "Social links saved successfully.",

                    timer: 1500,

                    showConfirmButton: false
                });


                navigate("/social-links");

            } else {

                let errorMessage =
                    data.message ||
                    "Something went wrong.";


                if (data.errors) {

                    const errors = Object.values(
                        data.errors
                    ).flat();


                    if (errors.length > 0) {

                        errorMessage =
                            errors.join("\n");
                    }
                }


                Swal.fire({

                    icon: "error",

                    title: "Unable to Save",

                    text: errorMessage
                });
            }

        } catch (error) {

            console.error(
                "Add Social Links Error:",
                error
            );


            Swal.fire({

                icon: "error",

                title: "Server Error",

                text:
                    "Unable to connect with server."
            });

        } finally {

            setSaving(false);
        }
    };


    /*
    |--------------------------------------------------------------------------
    | UI
    |--------------------------------------------------------------------------
    */

    return (

        <div
            className="container-fluid py-4"
            style={{
                maxHeight: "500px",
                overflowX: "auto",
                overflowY: "auto"
            }}
        >

            {/* Header */}

            <div className="d-flex justify-content-between align-items-center mb-4">

                <h3 className="mb-0">
                    Add Social Links
                </h3>


                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() =>
                        navigate("/social-links")
                    }
                >
                    Back
                </button>

            </div>


            {/* Card */}

            <div className="card shadow-sm">

                <div className="card-body">

                    <form onSubmit={handleSubmit}>


                        {/* WhatsApp */}

                        <div className="mb-3">

                            <label className="form-label fw-semibold">
                                WhatsApp Number
                            </label>

                            <input
                                type="tel"
                                className="form-control"
                                placeholder="919999999999"
                                value={whatsapp}
                                onChange={handleWhatsappChange}
                                maxLength="15"
                                inputMode="numeric"
                            />

                             <small className="text-muted">
                               only enter whatsapp number like 919999999999
                            </small>

                        </div>


                        {/* Instagram */}

                        <div className="mb-3">

                            <label className="form-label fw-semibold">
                                Instagram
                            </label>

                            <input
                                type="url"
                                className="form-control"
                                placeholder="https://instagram.com/homoeoadda"
                                value={instagram}
                                onChange={(e) =>
                                    setInstagram(e.target.value)
                                }
                            />

                        </div>


                        {/* Facebook */}

                        <div className="mb-3">

                            <label className="form-label fw-semibold">
                                Facebook
                            </label>

                            <input
                                type="url"
                                className="form-control"
                                placeholder="https://facebook.com/homoeoadda"
                                value={facebook}
                                onChange={(e) =>
                                    setFacebook(e.target.value)
                                }
                            />

                        </div>


                        {/* YouTube */}

                        <div className="mb-3">

                            <label className="form-label fw-semibold">
                                YouTube
                            </label>

                            <input
                                type="url"
                                className="form-control"
                                placeholder="https://youtube.com/@homoeoadda"
                                value={youtube}
                                onChange={(e) =>
                                    setYoutube(e.target.value)
                                }
                            />

                        </div>


                        {/* Telegram */}

                        <div className="mb-3">

                            <label className="form-label fw-semibold">
                                Telegram
                            </label>

                            <input
                                type="url"
                                className="form-control"
                                placeholder="https://t.me/homoeoadda"
                                value={telegram}
                                onChange={(e) =>
                                    setTelegram(e.target.value)
                                }
                            />

                        </div>


                        {/* Mobile */}

                        <div className="mb-3">

                            <label className="form-label fw-semibold">
                                Mobile Number
                            </label>

                            <input
                                type="tel"
                                className="form-control"
                                placeholder="9999999999"
                                maxLength="15"
                                inputMode="numeric"
                                value={mobile}
                                onChange={handleMobileChange}
                            />

                        </div>


                        {/* Status */}

                        <div className="mb-4">

                            <label className="form-label fw-semibold">
                                Status
                            </label>

                            <select
                                className="form-select"
                                value={status}
                                onChange={(e) =>
                                    setStatus(e.target.value)
                                }
                            >

                                <option value="Enable">
                                    Enable
                                </option>

                                <option value="Disable">
                                    Disable
                                </option>

                            </select>

                        </div>


                        {/* Buttons */}

                        <div className="d-flex gap-2">

                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={saving}
                            >

                                {saving ? (

                                    <>
                                        <span
                                            className="spinner-border spinner-border-sm me-2"
                                            role="status"
                                        />

                                        Saving...
                                    </>

                                ) : (

                                    "Save Social Links"

                                )}

                            </button>


                            <button
                                type="button"
                                className="btn btn-secondary"
                                disabled={saving}
                                onClick={() =>
                                    navigate("/social-links")
                                }
                            >
                                Cancel
                            </button>

                        </div>

                    </form>

                </div>

            </div>

        </div>
    );
}


export default AddSocialLinks;